import React from "react";
import { makeStyles, IconButton, List, ListItem } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import { FileIcon } from "../FileIcon";
import { trimText } from "../../util/functions";

const useStyles = makeStyles(theme => ({
  root: {
    width: 150,
    height: 150,
    background: "#FFFFFF",
    border: "1px solid #CACCD1",
    boxSizing: "border-box",
    boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.2)",
    borderRadius: "5px",
    margin: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
    flexDirection: "column",
    padding: theme.spacing(1),
    position: "relative",
    fontSize: "10px",
    lineHeight: "16px"
  },
  row: {
    marginBottom: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between"
  },
  icon: {
    width: 75,
    height: 75
  },
  fileMenu: {
    display: "flex",
    flexDirection: "column"
  },
  actionsMenu: {
    position: "absolute",
    top: 0,
    right: 0,
    height: 150,
    width: "60%",
    backgroundColor: "rgba(89, 110, 121, 0.8)",
    boxSizing: "border-box",
    borderBottomRightRadius: 5,
    borderTopRightRadius: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  },
  actionIconButton: {
    margin: theme.spacing()
  },
  menu: {
    width: "100%"
  },
  menuItem: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: "#FFF",
    cursor: "pointer",
	fontSize: "12px",
	"&:hover": {
		backgroundColor: '#d0101b'
	}
  },
  fileName: {
    color: "#304967"
  },
  fileSize: {
    color: "#BDBDBD"
  }
}));

function AttachmentCard({
  id,
  mimeType,
  fileName,
  fileSize,
  fileLink,
  download,
  removeDocument,
  showmenu = true
}) {
  const classes = useStyles();

  const [showActionsMenu, setShowActionsMenu] = React.useState(false);

  const baseURL = "/work/api/file";

  const toggleActionsMenu = () => {
    setShowActionsMenu(show => !show);
  };

  const closeActionsMenu = () => {
    setShowActionsMenu(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div className={classes.icon}>
          <FileIcon mimeType={mimeType} />
        </div>
        <ClickAwayListener onClickAway={closeActionsMenu}>
          <div>
            <div className={classes.fileMenu}>
              {showmenu &&
              <IconButton size="small" onClick={toggleActionsMenu}>
                <MoreHorizIcon fontSize="small" />
              </IconButton>}
              <IconButton
                size="small"
                href={`${baseURL}/${fileLink}${
                  download ? "?download=true" : ""
                }`}
                target={download ? "_self" : "_blank"}
              >
                <CloudDownloadOutlinedIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        </ClickAwayListener>
      </div>
      <div className={classes.fileName}>{trimText(fileName,20,'...')}</div>
      <div className={classes.fileSize}>{fileSize}</div>
      {showActionsMenu && (
        <div className={classes.actionsMenu}>
          <IconButton
            size="small"
            onClick={closeActionsMenu}
            className={classes.actionIconButton}
          >
            <MoreHorizIcon fontSize="small" style={{ color: "#FFF" }} />
          </IconButton>
          <List className={classes.menu}>
            <ListItem
              className={classes.menuItem}
              onClick={() => {
                closeActionsMenu();
                removeDocument();
              }}
            >
              Удалить
            </ListItem>
          </List>
        </div>
      )}
    </div>
  );
}

export default AttachmentCard;
